import { useInfiniteQuery, type InfiniteData, type UseInfiniteQueryResult } from '@tanstack/react-query';
import { fetchControlRiskFilterOptionsPage } from '../../request/controls/controlRiskMappings.ts';

export const controlRiskWithProcessMappingsQueryKey = (search: string, auditYearId?: string | null) =>
  ['controls', 'risk-with-process-mappings-options', search, auditYearId ?? null] as const;

export type ControlRiskFilterOptionsPageView = Awaited<ReturnType<typeof fetchControlRiskFilterOptionsPage>>;

export function useControlRiskFilterOptions(
  search: string,
  enabled = true,
  auditYearId?: string | null,
): UseInfiniteQueryResult<InfiniteData<ControlRiskFilterOptionsPageView>, Error> {
  return useInfiniteQuery({
    queryKey: controlRiskWithProcessMappingsQueryKey(search, auditYearId),
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      fetchControlRiskFilterOptionsPage({ page: Number(pageParam) || 1, pageSize: 20, search, auditYearId }),
    getNextPageParam: (lastPage) => {
      const items = lastPage.items;
      if (!Array.isArray(items) || items.length === 0) return undefined;
      const pageSize = lastPage.pageSize || 20;
      if (lastPage.isLastPage === true) return undefined;
      if (lastPage.isLastPage == null && items.length < pageSize) return undefined;
      const page = typeof lastPage.page === 'number' && Number.isFinite(lastPage.page) ? lastPage.page : 1;
      return page + 1;
    },
  });
}
